module.exports = __webpack_public_path__ + "static/media/nature_on_screen.76ccbd5a.svg";